$(document).ready(function() {

    /* Beim Klick auf den Liste - Tab */
    $(".ttgTabListeBtn").click(function() {
        $(".showItemsTextAndPaging").show();
        $(".ttgSortierungen").show();
        $(".ttgTourdataListItems").show();
        $(".ttgListKarte").addClass('listKarteHide');
        $(this).addClass('ttgTabActive');
        $(".ttgTabKarteBtn").removeClass('ttgTabActive');

        if ($('.ttgMerkzettelMouseMoveDescription').length) {
            $('.ttgMerkzettelMouseMoveDescription').show();
        }
    });

    /* Beim Klick auf den Karte - Tab */
    $(".ttgTabKarteBtn").click(function() {
        $(".ttgTourdataListItems").hide();
        $(".showItemsTextAndPaging").hide();
        $(".ttgSortierungen").hide();
        $(".ttgListKarte").removeClass('listKarteHide');
        $(this).addClass('ttgTabActive');
        $(".ttgTabListeBtn").removeClass('ttgTabActive');

        if ($('.ttgMerkzettelMouseMoveDescription').length) {
            $('.ttgMerkzettelMouseMoveDescription').hide();
        }

        if ($('#mapInner').length && $("#ttgDetailTabs").attr("data-metaAjaxRequest") != "true") {
            if ($(".ttgDataWrapperOnlyNeededForJS").attr("data-mapVersion") == "gmap") {
                GetECInnerMap();
            } else {
                leafLeftResize(ecMap);
            }
        }

        if ($("#ttgDetailTabs").attr("data-metaAjaxRequest") == "true") {
            if ($(".ttgDataWrapperOnlyNeededForJS").attr("data-mapVersion") == "gmap") {
                google.maps.event.trigger(ecMap.gMap, 'resize');
            }
            setTimeout(function() {
                ecMap.SetMapView(layer.GetBoundingRectangle());
            }, 200);
        }
    });

    /* Bei Klick auf das Karte-Icon soll die Sortierung ausgeblendet werden */
    $('.ttgIconShowOnMap').click(function() {
        $(".ttgSortierungen").hide();
    });


    /* Ausnahme: Die Merkzettel- und Karte-Icon bei der Liste soll nicht auf die Detailseite verlinken -> das ganze List-Item soll klickbar sein  */
    $(document).on("click", ".ttgListShare", function() {
        var thisObj = $(this);
        thisObj.addClass("ttgListShareClicked");
        setTimeout(function() {
            thisObj.removeClass("ttgListShareClicked");
        }, 1000);
        return false;
    });

    /* Listen-Elemente sollen als Ganzes klickbar sein */
    $(".ttgListItemWrapper").click(function() {
        var thisObj = $(this);
        setTimeout(function() {

            // bei der META-Vermieter Liste den Klick nicht ausführen, wird separat behandelt
            if ($(".ttgMetaSucheRightFilterWrapper").length == 0 && thisObj.find('.ttgListShareClicked').length == 0) {
                var url = thisObj.find("a").attr("href");
                if (thisObj.hasClass('ttgListMitBilder')) {

                    var target = thisObj.find("a").attr("target");

                    if (url.indexOf('://') > 0 || url.indexOf('//') === 0) {
                        // URL is absolute; either "http://example.com" or "//example.com"
                        if (target == "_blank") {
                            window.open(url);
                        } else {
                            window.location.href = url;
                        }
                    } else {
                        // URL is relative
                        window.location.href = '/' + url;
                    }
                } else {
                    window.location.href = url;
                }
                return false;
            }
        }, 250);
    });

    /* MOBILE: Ausspielung des Merkzettel- und Karte-Icons neben Titel */
    if ($('.ttgListShare').length) {
        if ($(window).width() >= 480 && $(window).width() <= 768) {
            $('.ttgListShare').each(function() {
                $(this).appendTo($(this).closest('.ttgListItemWrapper').children().find('.ttgMobileMerkenKarteWrapper'));
            });
        }
    }

});

function leafLeftResize(ecMapObj) {
    var LMap = ecMapObj.GetLMap();
    LMap.invalidateSize(true);
}

$(window).resize(function() {
    if ($('.ttgListShare').length) {

        /* MOBILE: Ausspielung des Merkzettel- und Karte-Icons neben Titel */
        if ($(window).width() >= 480 && $(window).width() <= 768) {
            $('.ttgListShare').each(function() {
                $(this).appendTo($(this).closest('.ttgListItemWrapper').children().find('.ttgMobileMerkenKarteWrapper'));
            });
        }

        if ($(window).width() < 480 || $(window).width() > 768) {
            $('.ttgListShare').each(function() {
                $(this).appendTo($(this).closest('.ttgListItemWrapper').children().find('.ttgIconsAndShareWrapper'));
            });
        }
    }
});